import Button from '@components/_Revamp/Button';
import { TitleAndDescription } from '@components/_Revamp/TitleAndDescription/TitleAndDescription';
import { styled } from '@linaria/react';
import React, { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';

import submitSucessBackground from '@assets/images/contact-form-submit-success.png';

const SubmitSuccessWraper = styled.div`
  width: 100%;
  height: calc(100vh - 150px);
  position: relative;
`;

const SubmitSuccessImage = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 60vh;
  z-index: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const SubmitSucessContainer = styled.div`
  max-width: 588px;
  margin: 150px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 64px;
  position: relative;
  z-index: 1;
`;

export interface SubmitSuccessProps { }

export const SubmitSuccess = forwardRef<HTMLDivElement, SubmitSuccessProps>(
  (props: SubmitSuccessProps, ref) => {
    const history = useHistory();

    const backtoHome = () => {
      history.push('/mltc/lets-get-started');
    };

    return (
      <SubmitSuccessWraper>
        <SubmitSucessContainer ref={ref}>
          <TitleAndDescription
            title="Hooray! We will be in touch with you soon."
            description="Otherwise you can also call us at 6827 9933 or drop us an email at cs_life@singlife.com"
            descriptionMaxWidth={343}
          />
          <Button label="Back to home" width="285px" onClick={backtoHome} />
        </SubmitSucessContainer>
        <SubmitSuccessImage>
          <img src={submitSucessBackground} alt="submit-success-background" />
        </SubmitSuccessImage>
      </SubmitSuccessWraper>
    );
  }
);
